<mat-divider></mat-divider>

<div class="titulo-seccion">
    <span>
        <ng-content></ng-content>
    </span>
</div>